import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { PDFDocument } from 'pdf-lib';
import JSZip from 'jszip';
import { ENDPOINT } from 'constants/variables';
import { helpHttp } from 'service/HelpHttp';
import ReportTemplateShipping from 'pages/shipping/generatePDF/ReportTemplateShipping';

export const buildShippingDownload = async (files, mode) => {
  if (mode === 'zip') {
    const zip = new JSZip();
    for (const file of files) zip.file(`CartaPortes_${file.code}_${file.id}.pdf`, await file.blob.arrayBuffer());
    return zip.generateAsync({ type: 'blob', compression: 'DEFLATE' });
  }
  const merged = await PDFDocument.create();
  for (const file of files) {
    const pdf = await PDFDocument.load(await file.blob.arrayBuffer());
    const pages = await merged.copyPages(pdf, pdf.getPageIndices());
    pages.forEach((page) => merged.addPage(page));
  }
  return new Blob([await merged.save()], { type: 'application/pdf' });
};

const ShippingBatchDownload = ({ job, onComplete, onError }) => {
  const token = useSelector((state) => state.loginUser.token);
  const [index, setIndex] = useState(0);
  const [shipping, setShipping] = useState(null);
  const files = useRef([]);
  const active = useRef(true);
  const processing = useRef(false);
  useEffect(() => {
    active.current = true;
    return () => { active.current = false; };
  }, []);
  useEffect(() => {
    let cancelled = false;
    const timeout = setTimeout(() => { if (!cancelled) onError(); }, 120000);
    const load = async () => {
      try {
        const data = await helpHttp().get2(ENDPOINT, 'shipping/getshippingbyid/', token, job.rows[index].id);
        if (!data?.id || data.err) throw new Error('Missing shipping');
        if (!cancelled) { processing.current = false; setShipping(data); }
      } catch (error) { if (!cancelled) onError(); }
    };
    load();
    return () => { cancelled = true; clearTimeout(timeout); };
  }, [index, job, token, onError]);
  const collect = useCallback(async (blob) => {
    if (!active.current || processing.current) return;
    processing.current = true;
    const row = job.rows[index];
    files.current.push({ blob, id: row.id, code: String(row.ownshipping_id).padStart(6, '0') });
    setShipping(null);
    if (index + 1 < job.rows.length) { setIndex((value) => value + 1); return; }
    try {
      const output = await buildShippingDownload(files.current, job.mode);
      if (!active.current) return;
      const url = URL.createObjectURL(output);
      const link = document.createElement('a');
      link.href = url;
      link.download = job.mode === 'zip' ? 'CartasPortes.zip' : 'CartasPortes.pdf';
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
      onComplete();
    } catch (error) { if (active.current) onError(); }
  }, [index, job, onComplete, onError]);
  return shipping ? <ReportTemplateShipping key={shipping.id} dataShipping={shipping} setPdfBlob={collect} /> : null;
};
export default ShippingBatchDownload;
